import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { DictionaryModel } from '@core/models/dictionary.model';
import { TaskTypeColorPipe } from './pipes/task-type-color.pipe';
import { TaskTypeAcronymPipe } from "./pipes/task-type-acronym.pipe";
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'delivery-type-icon',
  standalone: true,
  imports: [CommonModule, TaskTypeColorPipe, TaskTypeAcronymPipe, MatTooltipModule],
  templateUrl: './delivery-type-icon.component.html',
  styleUrl: './delivery-type-icon.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DeliveryTypeIconComponent {
  @Input() taskType!: DictionaryModel;
}
